"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _reactDom = require("react-dom");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _UIAbstractIconDropdown = _interopRequireDefault(require("./abstract/UIAbstractIconDropdown"));

var _UITextToolbarButton = _interopRequireDefault(require("./UITextToolbarButton"));

var _UITextToolbarIcon = _interopRequireDefault(require("./UITextToolbarIcon"));

var _Controllable = _interopRequireDefault(require("../decorators/Controllable"));

var _UIButtonGroup = _interopRequireDefault(require("../button/UIButtonGroup"));

var _UITooltip = _interopRequireDefault(require("../tooltip/UITooltip"));

var StyledButtonGroup = (0, _styledComponents.default)(_UIButtonGroup.default).withConfig({
  displayName: "UITextToolbarSplitSelect__StyledButtonGroup",
  componentId: "ob1ofe-0"
})(["& > *[aria-disabled='true']{border-color:transparent !important;}"]);

var UITextToolbarSplitSelect = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(UITextToolbarSplitSelect, _Component);

  function UITextToolbarSplitSelect() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, UITextToolbarSplitSelect);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(UITextToolbarSplitSelect)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _this.refCallback = function (element) {
      _this._popoverTarget = (0, _reactDom.findDOMNode)(element);
    };

    return _this;
  }

  (0, _createClass2.default)(UITextToolbarSplitSelect, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          active = _this$props.active,
          open = _this$props.open,
          options = _this$props.options,
          onButtonClick = _this$props.onButtonClick,
          placement = _this$props.placement,
          tooltip = _this$props.tooltip,
          value = _this$props.value,
          splitButtonTestId = _this$props.splitButtonTestId,
          disabled = _this$props.disabled,
          rest = (0, _objectWithoutProperties2.default)(_this$props, ["active", "open", "options", "onButtonClick", "placement", "tooltip", "value", "splitButtonTestId", "disabled"]);
      var selectedOption = options.find(function (_ref) {
        var val = _ref.value;
        return val === value;
      });
      var renderedIcon = selectedOption ? _react.default.createElement(_UITextToolbarIcon.default, {
        disabled: disabled,
        name: selectedOption.icon
      }) : null;
      var popoverProps = {
        target: this._popoverTarget
      };
      return _react.default.createElement(_UITooltip.default, {
        open: open ? false : undefined,
        placement: placement,
        title: tooltip,
        disabled: disabled
      }, _react.default.createElement(StyledButtonGroup, {
        disabled: disabled
      }, _react.default.createElement(_UITextToolbarButton.default, {
        "data-test-id": splitButtonTestId,
        hovered: open ? true : undefined,
        onClick: onButtonClick,
        ref: this.refCallback,
        selected: active,
        disabled: disabled
      }, renderedIcon), _react.default.createElement(_UIAbstractIconDropdown.default, Object.assign({
        open: open,
        options: options,
        popoverProps: popoverProps,
        value: value,
        disabled: disabled
      }, rest))));
    }
  }]);
  return UITextToolbarSplitSelect;
}(_react.Component);

UITextToolbarSplitSelect.propTypes = Object.assign({}, _UIAbstractIconDropdown.default.propTypes, {
  active: _propTypes.default.bool,
  onButtonClick: _propTypes.default.func,
  placement: _UITooltip.default.propTypes.placement,
  tooltip: _UITooltip.default.propTypes.title,
  splitButtonTestId: _propTypes.default.string
});
UITextToolbarSplitSelect.defaultProps = Object.assign({}, _UIAbstractIconDropdown.default.defaultProps, {
  active: false,
  placement: 'bottom'
});
UITextToolbarSplitSelect.displayName = 'UITextToolbarSplitSelect';

var _default = (0, _Controllable.default)(UITextToolbarSplitSelect, ['open', 'value']);

exports.default = _default;
module.exports = exports.default;